import React, { useState } from "react"
import { useProfile } from "../../contexts/ProfileContextProvider"
import { tjanster, branscher } from "./boardingData"
import * as m from "framer-motion/m"
import DataFilterList from "../DataFilterList/DataFilterList"
import InputField from "../UIComponents/InputField"
const variants = {
    hidden: {
        transition: { staggerChildren: 0.1, staggerDirection: -1 },
    },
    visible: {
        transition: { staggerChildren: 0.1, staggerDirection: -1 },
    },
    exit: {
        transition: { staggerChildren: 0.1, staggerDirection: 1, duration: 1 },
    },
}

const itemVariants = {
    hidden: {
        opacity: 0,
    },
    visible: {
        opacity: 1,

        transition: {
            duration: 0.3,
        },
    },
    exit: {
        opacity: 0,
    },
}

const btnVariants = {
    hidden: {
        opacity: 0,
        y: 40,
        scale: 0.97,
    },
    visible: {
        opacity: 1,
        y: 0,
        scale: 1,
        transition: {
            duration: 0.3,
        },
    },
    exit: {
        opacity: 0,
    },
}
const OptionsSection = () => {
    const { contextSetProfileData, profileData } = useProfile()
    const [profileName, setProfileName] = useState(profileData.name || "")
    const [selectedBranscher, setSelectedBranscher] = useState(
        profileData.branscher || [],
    )
    const [selectedTjanster, setSelectedTjanster] = useState(
        profileData.tjanster || [],
    )

    const handleNameInput = (e) => {
        setProfileName(e.target.value)
    }

    const handleCreateProfile = () => {
        const obj = {
            branscher: selectedBranscher,
            tjanster: selectedTjanster,
            name: profileName,
        }
        contextSetProfileData(obj)
    }

    return (
        <m.div
            variants={variants}
            initial="hidden"
            animate="visible"
            exit="exit"
            className="flex flex-col justify-start w-full max-w-2xl mx-auto space-y-4 pb-32"
        >
            <m.div variants={itemVariants}>
                <m.h2 className="text-2xl text-primary-500 font-bold text-center">
                    Välkommen!
                </m.h2>
                <m.p className="text-center max-w-[65ch] fg-color-3">
                    Här kan du skapa din personliga profil. <br /> Välj vilka
                    bransher och tjänser som du är intresserad av.
                </m.p>
            </m.div>
            <m.div variants={btnVariants}>
                <p className="font-bold fg-color-2 mb-2">Vad heter du?</p>
                <InputField
                    placeholder="Skriv ditt namn..."
                    query={profileName}
                    handleQuery={handleNameInput}
                    resetQuery={() => setProfileName("")}
                />
            </m.div>

            <m.div variants={btnVariants} className="space-y-2">
                <h3 className="font-bold fg-color-2">Välj Branscher</h3>
                <DataFilterList
                    items={branscher}
                    selectedItems={selectedBranscher}
                    setSelectedItems={setSelectedBranscher}
                />
            </m.div>
            <m.div variants={btnVariants} className="space-y-2">
                <h3 className="font-bold fg-color-2">Välj Tjänster</h3>
                <DataFilterList
                    items={tjanster}
                    selectedItems={selectedTjanster}
                    setSelectedItems={setSelectedTjanster}
                />
            </m.div>

            <m.div
                variants={btnVariants}
                className="px-4 pb-safe fixed flex justify-center bottom-0 left-0 w-full bg-color-1"
            >
                <div className="py-4 flex w-full max-w-2xl border-t border--color-1">
                    <button
                        onClick={handleCreateProfile}
                        className={
                            "w-full bg-neutral-900 dark:bg-neutral-100 text-neutral-100 dark:text-neutral-900 p-4 rounded-lg hover:bg-neutral-800 dark:hover:bg-neutral-200"
                        }
                    >
                        Skapa Profil
                    </button>
                </div>
            </m.div>
        </m.div>
    )
}

export default OptionsSection
